// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 804) return "static/chunks/804-7b138755ddf4893e.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"296":"ea88be26","8886":"936c25f7"}[chunkId] || chunkId) + "." + {"296":"6fc2bdc0617142ae","3734":"9a796a1ffb8483aa","8886":"c99aea5a297f832f","9464":"9bd15bc6249c8ce5"}[chunkId] + ".js";
};